import { useQuery } from '@tanstack/react-query'
import { getTransactionDetails } from '../requests'
import { TransactionDetails } from '../transaction_detail.schema'

const GET_TRANSACTION_QUERY_KEY = (
  program_id: number,
  transaction_id?: number
) => ['transaction', transaction_id, program_id]

export const useTransactionDetails = (
  program_id: number,
  transactionId?: number
) => {
  return useQuery<TransactionDetails>({
    queryKey: GET_TRANSACTION_QUERY_KEY(program_id, transactionId),
    queryFn: () => getTransactionDetails(program_id, transactionId),
  })
}
